import { formatUserFacingError } from '@/lib/errors'
import { useCallback, useEffect, useState } from 'react'
import { providerInvoicesService } from '../services/providerInvoices.service'
import type { ProviderInvoiceDocument } from '@/types'

export function useMyInvoices(memberId: string | null) {
  const [data, setData] = useState<Array<ProviderInvoiceDocument & { id: string }>>([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const refresh = useCallback(async () => {
    if (!memberId) {
      setData([])
      return
    }
    setLoading(true)
    setError(null)
    try {
      setData(await providerInvoicesService.listForMember(memberId))
    } catch (e) {
      setError(formatUserFacingError(e, 'Failed to load invoices'))
    } finally {
      setLoading(false)
    }
  }, [memberId])

  useEffect(() => {
    void refresh()
  }, [refresh])

  return { data, loading, error, refresh }
}
